@let shift = this.shift();

@if (shift) {
    <div [ngClass]="{ 'ion-margin-top': topMargin(), 'ion-margin-bottom': bottomMargin() }">
        <lib-card [button]="button()" (cardClicked)="click()">
            @if (shift.event_type) {
                <div
                    ngProjectAs="header"
                    class="margin-bottom-small flex align-items-center justify-content-space-between">
                    <div class="flex align-items-center">
                        @if (shift.client_profile_image) {
                            <lib-avatar-image
                                class="margin-right-small"
                                [customSize]="48"
                                [image]="shift.client_profile_image" />
                        }
                        <h2>{{ shift.event_type }}</h2>
                    </div>
                    @if (displayStatus()) {
                        <lib-status-chip
                            type="shift"
                            [status]="shift.status"
                            [endDateTime]="shift.end_date + 'T' + shift.end_time" />
                    }
                    @if (displayRate()) {
                        <p class="text-midsmall">
                            <span class="text-primary h4 font-weight-medium">
                                {{ shift.rate | currencyCustom }}
                            </span>
                            / hour
                        </p>
                    }
                </div>
            }

            <div>
                <div class="chip-item chip-white chip-small">
                    <p>
                        @if (shift.start_date === dateToday()) {
                            Today
                        } @else {
                            {{ shift.start_date | date }}
                        }
                    </p>
                </div>

                <div class="chip-item chip-white chip-small">
                    <p>
                        {{ shift.start_date + ' ' + shift.start_time | date: 'h:mma' | lowercase }} -
                        {{ shift.end_date + ' ' + shift.end_time | date: 'h:mma' | lowercase }}
                    </p>
                </div>

                @if (displayDistance()) {
                    <div class="chip-item chip-white chip-small">
                        <p>{{ shift.distance_from_job }} mi from you</p>
                    </div>
                }
            </div>
        </lib-card>
    </div>
}
